import { INVALIDATE, SUGGESTIONS_ERROR, SUGGESTIONS_LOADED } from '../actions/issueSuggestions';

export default function issueSuggestions(state = {}, action) {
  switch (action.type) {
    case SUGGESTIONS_LOADED: {
      return Object.assign({}, state, {
        [action.search]: {
          error: null,
          lastUpdated: action.timestamp,
          loading: false,
          items: action.suggestions,
        },
      });
    }

    case SUGGESTIONS_ERROR: {
      return Object.assign({}, state, {
        [action.search]: {
          error: action.error,
          lastUpdated: action.timestamp,
          loading: false,
          items: null,
        },
      });
    }

    case INVALIDATE: {
      return {};
    }

    default:
      return state;
  }
}
